var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#303030;stroke-width:0.7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#303030;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "Padding__x26__Artboard"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.1311,35.0978H17.8689c-2.74303,0-4.9667-2.22366-4.9667-4.9667V17.8689   c0-2.74303,2.22367-4.9667,4.9667-4.9667H30.1311c2.74303,0,4.9667,2.22367,4.9667,4.9667V30.1311   C35.0978,32.87414,32.87414,35.0978,30.1311,35.0978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 24,
    x2: 24,
    y1: 20.14733,
    y2: 27.85267
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 20.14733,
    x2: 27.85267,
    y1: 24,
    y2: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlius);
export default __webpack_public_path__ + "static/media/plius.ccef14a779ebdfb76d667194e6695b3a.svg";
export { ForwardRef as ReactComponent };